export interface ITableLineCloneItem {
    sectionIdentifier: string;
    selected: boolean;
}

export class TableLineCloneItem implements ITableLineCloneItem {
    public sectionIdentifier: string;
    public selected: boolean;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableLineCloneItem);
    constructor(obj?: any) {
        this.sectionIdentifier = obj && obj.sectionIdentifier || '';
        this.selected = obj && obj.selected || false;
    }
}
